module.exports = __webpack_public_path__ + "img/promotion.7094c1aa.svg";